<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <div style="color: orangered;margin-left: 2%">信號源庫列表數據為每天00：00：00進行更新，非實時數據</div>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="sourceLibUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE ref="sourceConfig" @submit="submitConfig" :updateData="sourceConfig"></UPDATE>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/merchandiser/util/url'
import UPDATE from '@/components/page/update'

let types = { 1: '新进信号源', 2: '历史信号源', 3: '不合格信号源' },//信号源属性
  statusArr = { 2: '禁用', 1: '啟用' },
  signalStatus = { 1: '是', 0: '否' },
  userType = { 1: '代理', 2: '標準', 3: '行家', 4: '大師', 5: '傳奇' },
  companyCodeName = {}, company = {},
  platformList = { 'GTS2': 'GTS2', 'MT5': 'MT5' }
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  mounted() {

  },
  created() {
    this.initCompanys()
  },
  methods: {
    initCompanys() {
      this.dataChange(Url.company.companyListAll, {}, res => {
        if (res.code == 0) {
          for (let i in res.result) {
            companyCodeName[res.result[i].companyId] = res.result[i].name
            company[res.result[i].companyId] = res.result[i]
          }
        } else {
          this.$message.error('加載公司列表失敗')
        }
      })
    },
    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('更新信號源' == clickName) {
        this.updateLib()
      } else if ('设置信号源筛选条件' == clickName) {
        this.dataChange(Url.signal.configGet, {}, res => {
          if (res.code == 0) {
            this.$refs.sourceConfig.open(res.result)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    updateLib() {
      this.dataChange(Url.signal.libUpdate, {}, res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submit(model) {
      model.allowedPlatform = model.allowedPlatform.join(',')
      this.dataChange(Url.signal.libAsSignal, model, res => {
        if (res.code == 0) {
          this.$refs.sourceLibUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submitConfig(model) {
      this.dataChange(Url.signal.configEdit, model, res => {
        if (res.code == 0) {
          this.$refs.sourceConfig.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'addAsSignal') {
        this.$refs.sourceLibUpdate.open(row)
      } else if (clickName == 'tradeDetail') {
        this.$refs.sourceLibUpdate.open(row)
      }
    },
    bussinessType(model) {
      let assigningCompanyId = model.assigningCompanyId
      let result = {}
      if (assigningCompanyId != undefined && assigningCompanyId != null) {
        let businessTypes = company[assigningCompanyId].businessTypes.split(',')
        for (const i in businessTypes) {
          result[businessTypes[i]] = businessTypes[i]
        }
      }
      return result
    }
  },
  data() {
    return {
      queryData: {},
      sourceConfig: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: '統計歷史週期天數', field: 'perDay', type: 7, required: true, remarkType: true, remarkTxt: '以當天開始，往歷史日期倒查' },
          {
            title: '統計範圍內所需交易天數',
            field: 'hasTradeDays',
            type: 7,
            required: true,
            remarkType: true,
            remarkTxt: '在統計範圍內需要達到的交易天數'
          },
          {
            title: '最近多少天有交易',
            field: 'recentHasTrade',
            type: 7,
            required: true,
            remarkType: true,
            remarkTxt: '以當天開始，最近需要有交易的天數'
          },
          {
            title: '收益率(%)',
            field: 'rateReturn',
            required: true,
            type: 7,
            remarkType: true,
            remarkTxt: '平仓盈亏金额总和 / 开仓保证金金额总和 * 100%'
          },
          {
            title: '平仓胜率(%)',
            field: 'rateWinning',
            required: true,
            type: 7,
            remarkType: true,
            remarkTxt: '平仓盈利笔数总和 / 平仓笔数总和 * 100%'
          },
          {
            title: '平倉盈利筆數', field: 'winningTotal', required: true, type: 7,
            remarkType: true,
            remarkTxt: '已平倉的訂單，盈利筆數的最少要求'
          }
        ]
      },
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: 'accountID', field: 'accountId', readonly: true },
          { title: '信号源交易账号', field: 'customerNumber' },
          { title: '信号源所属公司', field: 'companyId', required: true },
          { title: '信号源所屬平臺', field: 'platform', required: true, type: 2, optionList: platformList, data: [] },
          { title: '信号源所屬业务', field: 'businessType' },
          {
            title: '指派公司',
            field: 'assigningCompanyId',
            required: true,
            type: 2,
            optionList: companyCodeName
          },

          {
            title: '指派业务',
            field: 'assigningBusinessType',
            required: true,
            type: 2,
            optionListObjRender: (model, col) => {
              return this.bussinessType(model)
            }
          },
          { title: '初始跟單人數', field: 'initTrack', required: true },
          { title: '最多允许跟单人数', field: 'maxTrack', required: true },
          { title: '支持平台', field: 'allowedPlatform', required: true, type: 4, optionList: platformList, data: [] },
          { title: 'UI端昵称', field: 'nickName', required: true },
          { title: '头像', field: 'imgUrl', required: true },
          { title: '信号源类型', field: 'userType', required: true, type: 2, optionList: userType },
          { title: '利润分成', field: 'profitSharing', required: true, isNumber: true },
          { title: '简介', field: 'remark' }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '信号源賬號', field: 'customerNumber' },
          { title: '信号源所属公司', field: 'companyId' },
          { title: '收益率大于等于', field: 'thirtyReturnRate' },
          { title: '盈利笔数大于等于', field: 'thirtyProfitableNum' },
          { title: '交易总笔数', field: 'thirtyTradePieceNum' },
          { title: '交易总手数大于等于', field: 'thirtyTradeLotNum' },
          { title: '平仓胜率手数大于等于', field: 'thirtyWinningRate' },
          {
            title: '信号源属性',
            field: 'sourceType',
            type: 2,
            optionList: types,
            multiple: false
          },
          {
            title: '是否已是信號源',
            field: 'signalStatus',
            type: 2,
            optionList: signalStatus,
            multiple: false
          },
          { click: window.$t('common.search') },
          { click: '设置信号源筛选条件', auth: 'merchandiser:config:setting' },
          { click: '更新信號源', auth: 'source:lig:update' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.signal.libList,
        selection: false,
        sequence: true,
        size: 10,
        method: 'get',
        cols: [
          { title: 'accountID', field: 'accountId' },
          { title: '信号源交易账号', field: 'customerNumber' },
          { title: '信号源所属公司', field: 'companyId' },
          { title: '信号源所属业务', field: 'businessType' },
          { title: '交易平台', field: 'platform' },
          {
            title: '信号源属性', field: 'sourceType', render: (data, full) => {
              return types[data]
            }
          },
          { title: '收益率(%)', field: 'thirtyReturnRate' },
          { title: '盈利笔数', field: 'thirtyProfitableNum' },
          { title: '交易总笔数', field: 'thirtyTradePieceNum' },
          { title: '平仓胜率(%)', field: 'thirtyWinningRate' },
          { title: '交易总手数', field: 'thirtyTradeLotNum' },
          { title: '有交易天數', field: 'hasTradeDays' },
          {
            title: '最近交易時間（統計範圍內）', field: 'recentTradeDay', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '是否信號源', field: 'signalStatus', render: (data, full) => {
              return signalStatus[data]
            }
          },
          {
            title: '生成時間', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            btnClick: [
              {
                name: '设置为信号源',
                click: 'addAsSignal',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'merchandiser:source:addAs'
                // hidden: (model, col) => {
                //   return col.status == 0 ? false : true
                // }
              }]
          }
        ]
      }
    }
  }
}
</script>
